import { render } from "./App.vue?vue&type=template&id=0f4ba3d7"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0f4ba3d7&lang=scss"

import exportComponent from "/builds/julienanthonyweb/casa-portugal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__